import { Injectable } from '@angular/core';

import { Edp, PromotionModel } from '@bytel/bytel-sales';
import { CartCheckoutService, CheckoutCartModel, FundingMethod, PromotionRepository } from '@bytel/checkout';

import { Observable, throwError } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { ModalPricesCompatibilityComponent } from '../shared/promotion/coupon/modal/modal-prices-compatibility/modal-prices-compatibility.component';
import { MessageService } from './message.service';

@Injectable({
    providedIn: 'root',
})
export class PromoCodeCompatibilityService {
    public valid: boolean = false;
    public add: boolean = false;

    constructor(
        private messageService: MessageService,
        private promoRepo: PromotionRepository,
        private cartService: CartCheckoutService,
    ) {}

    public checkAddCoupon(cartModel: CheckoutCartModel, couponCode: string): Observable<PromotionModel> {
        let addedCoupon: PromotionModel;
        return this.promoRepo.getCouponPromotionForCart(cartModel, couponCode).pipe(
            mergeMap((coupon) => {
                if (coupon) {
                    addedCoupon = coupon;
                    return this.cartService.setCouponPromotion(cartModel, coupon);
                }
                return throwError('Erreur de coupon');
            }),
            map(() => addedCoupon),
        );
    }

    public showModal(
        toAdd: PromotionModel | Edp | FundingMethod,
        toDelete: PromotionModel | Edp | FundingMethod,
    ): Observable<any> {
        return new Observable<any>((obs) => {
            const products = {
                toAdd,
                toDelete,
            };

            this.messageService.openModal(
                ModalPricesCompatibilityComponent,
                {
                    products,
                },
                'medium',
                {
                    valid: (data) => {
                        if (data) {
                            obs.next(toAdd);
                            obs.complete();
                        } else {
                            obs.error();
                        }
                    },
                    close: () => obs.error(),
                },
            );
        });
    }
}
